import { gbp, priceSaving } from "@/lib/api";

// Retailer-side preview of how the comparison will appear to customers.
export const PriceCompareHint = ({ price, retail, basis }) => {
  if (!retail) return null;
  const s = priceSaving(parseFloat(price), parseFloat(retail));
  return (
    <p className="text-xs mt-2 text-slate-500" data-testid="price-compare-hint">
      {s
        ? <>Customers will see: <span className="font-semibold text-[#E05915]">Save {gbp(s.saved)} · {s.pct}% less</span> (both prices {basis}).</>
        : "No saving will be shown — the retail price must be higher than your selling price."}
    </p>
  );
};
